import React, { Component, Fragment } from "react";
import ExWriters from "./ExWriters";
import AppContext from "../../../contexts/AppContext";

export class WorkSpaceHeader extends Component {
    state = {
        togglePadding: 'mt-3'
    };
    componentDidMount() {
        if(this.context.state.user.email_verified === 'false') {
            this.setState({togglePadding: 'mt-15'});
          }
    }
    render() {
        return (
            <Fragment>
                <div className={`header pt-md-15 pb-md-40 pt-20 ${this.state.togglePadding}`}>
                    <div className="container employer-container">
                        <div className="header-body">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <div className="avatar avatar-lg avatar-4by3">
                                        <img
                                            src={this.props.job.user.image}
                                            alt={`${this.props.job.user.first_name} ${this.props.job.user.last_name}`}
                                            className="avatar-img rounded"
                                        />
                                    </div>
                                </div>
                                <div className="col ml-n3 ml-md-n2">
                                    <h6 className="header-pretitle">
                                        <span className="fe fe-clock"></span>{" "}
                                        <time
                                            className="timeago"
                                            dateTime={this.props.job.created_at}
                                        >
                                            {this.props.job.created_at}
                                        </time>
                                    </h6>

                                    <h1 className="header-title">
                                        {this.props.job.title}
                                    </h1>
                                </div>
                                <div className="col-12 col-md-auto mt-3 mt-md-0">
                                    <div className="avatar-group"></div>

                                    <ExWriters
                                        job_id={this.props.job.id}
                                    ></ExWriters>

                                    <div
                                        style={{
                                            background: "transparent",
                                            border: "0px",
                                            position: "absolute",
                                            "will-change": "transform",
                                            top: "0px",
                                            left: "0px",
                                            transform:
                                                "translate3d(16px, 43px, 0px)"
                                        }}
                                        className="dropdown-menu"
                                        aria-labelledby="users"
                                        x-placement="bottom-start"
                                    >
                                        <ul className="nav nav-sm flex-column"></ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col">
                                    <ul
                                        className="nav nav-tabs nav-overflow header-tabs"
                                        id="myTab"
                                        role="tablist"
                                    >
                                        <li className="nav-item">
                                            <a
                                                onClick={this.props.setActiveTab.bind(
                                                    this,
                                                    "description"
                                                )}
                                                id="desc-tab"
                                                data-toggle="tab"
                                                href="#desc"
                                                role="tab"
                                                aria-controls="desc"
                                                aria-selected="true"
                                                className={
                                                    this.props.activeTab ===
                                                    "description"
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                }
                                            >
                                                Description
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                onClick={this.props.setActiveTab.bind(
                                                    this,
                                                    "freelancers"
                                                )}
                                                className={
                                                    this.props.activeTab ===
                                                    "freelancers"
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                }
                                                id="free-tab"
                                                data-toggle="tab"
                                                href="#free"
                                                role="tab"
                                                aria-controls="free"
                                                aria-selected="false"
                                            >
                                                Freelancers
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

WorkSpaceHeader.contextType = AppContext;
export default WorkSpaceHeader;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/WorkSpaceHeader.js